import { render, staticRenderFns } from "./UploadImageStyle.vue?vue&type=template&id=4ceec9b5&scoped=true&"
import script from "./UploadImageStyle.vue?vue&type=script&lang=js&"
export * from "./UploadImageStyle.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageStyle.vue?vue&type=style&index=0&id=4ceec9b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceec9b5",
  null
  
)

export default component.exports